export default "__VITE_ASSET__9efca4ad__"